import { UserSession } from "@/types/session";
import { createContext } from "react";

export interface FeedbackContextType {
  showFeedbackModal: (sessionIds: UserSession["id"][]) => void;
  ratedSessionIds: UserSession["id"][] | null;
  closeFeedbackModal: () => void;
}

export const FeedbackContext = createContext<FeedbackContextType>({
  showFeedbackModal: () => {},
  ratedSessionIds: null,
  closeFeedbackModal: () => {},
});
